import { render, staticRenderFns } from "./AuthorNovels.vue?vue&type=template&id=6a22170e&scoped=true"
import script from "./AuthorNovels.vue?vue&type=script&lang=js"
export * from "./AuthorNovels.vue?vue&type=script&lang=js"
import style0 from "./AuthorNovels.vue?vue&type=style&index=0&id=6a22170e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22170e",
  null
  
)

export default component.exports